import { useRecoilState, useSetRecoilState } from 'recoil';
import { userAtom, accessTokenAtom, permissionAtom } from '../recoil/atoms';
import { PermissionT } from './usePermission';

type UserT = {
  id: number;
  email: string;
  displayName: string;
  role: string;
};

type UseAuthHookT = {
  isAuthenticated: boolean
  user: UserT | undefined
  authAction: {
    login: (accessToken: string, loginUser: UserT, permission: PermissionT[]) => {};
    logout: () => {};
  }
};
const useAuth = (): UseAuthHookT => {
  const [user, setUser] = useRecoilState(userAtom);
  const setAccessToken = useSetRecoilState(accessTokenAtom);
  const setPermissionAtom = useSetRecoilState(permissionAtom);
  const isAuthenticated = !!user;

  const authAction = {
    login: async (accessToken: string, loginUser: UserT, permission: PermissionT[]): Promise<void> => {
      setAccessToken(accessToken);
      setUser(loginUser);
      setPermissionAtom(permission);
    },
    logout: async (): Promise<void> => {
      setAccessToken(null);
      setUser(null);
      setPermissionAtom(null);
    },
  };

  return { isAuthenticated, user, authAction };
};

export default useAuth;
